<!-- eslint-disable vue/no-deprecated-v-on-native-modifier -->
<!-- src/views/Services.vue -->
<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <section class="serv">
  <div class="services-page">
    <!-- ===== HERO ===== -->
    <header class="sp-hero" data-anim style="--d:0ms">
      <div class="sp-hero__wrap">
        <span class="sp-badge">Nos expertises</span>
        <h1 class="sp-title">
          Des services <span class="sp-accent">complets &amp; sur-mesure</span>
        </h1>
        <p class="sp-subtitle">
          De l’idéation au déploiement, SpeDev conçoit, sécurise et fait évoluer vos produits.
          Découvrez en détails chaque domaine pour savoir exactement comment nous vous accompagnons.
        </p>

        <div class="sp-stats" data-anim style="--d:120ms">
          <div class="sp-stat"><strong>+50</strong><span>projets livrés</span></div>
          <div class="sp-stat"><strong>99.9%</strong><span>uptime clients</span></div>
          <div class="sp-stat"><strong>CI/CD</strong><span>déploiements sûrs</span></div>
        </div>
      </div>
    </header>

    <!-- ===== LAYOUT ===== -->
    <div class="sp-layout">
      <!-- Sommaire -->
      <aside class="sp-toc" aria-label="Sommaire">
        <p class="sp-toc__title">Parcourir</p>
        <ul>
          <li v-for="s in sections" :key="s.id">
            <a
              :href="'#' + s.id"
              @click.prevent="goTo('#' + s.id)"
              :class="{ active: activeAnchor === '#' + s.id }"
            >
              {{ s.title }}
            </a>
          </li>
        </ul>

        <div class="sp-toc__cta">
          <router-link
            to="/#contact1"
            class="sp-btn sp-btn--ghost"
            @click.native="goHomeTo('#contact1')"
          >
            Discuter de votre besoin
          </router-link>
        </div>
      </aside>

      <!-- Contenu -->
      <main class="sp-content">
        <section
          v-for="(s, i) in sections"
          :key="s.id"
          :id="s.id"
          class="sp-block"
          :class="{'sp-block--rev': i % 2 === 1, ['sp-theme--' + s.theme]: true}"
        >
          <figure class="sp-visual" data-anim :style="{ '--d': (i * 120) + 'ms' }">
            <picture>
              <img :src="s.image" :alt="s.title" loading="lazy" decoding="async" />
            </picture>
          </figure>

          <div class="sp-body">
            <div class="sp-eyebrow" data-anim :style="{ '--d': (i * 120) + 'ms' }">
              {{ s.eyebrow }}
            </div>

            <h2 class="sp-block__title" data-anim :style="{ '--d': (i * 120 + 80) + 'ms' }">
              <span class="sp-accent">{{ s.title }}</span>
            </h2>

            <p class="sp-lead" data-anim :style="{ '--d': (i * 120 + 140) + 'ms' }">
              {{ s.lead }}
            </p>

            <div class="sp-features" data-anim :style="{ '--d': (i * 120 + 200) + 'ms' }">
              <article v-for="(f, k) in s.features" :key="k" class="sp-feature">
                <div class="sp-feature__icon" aria-hidden="true" v-html="f.icon"></div>
                <div>
                  <h3 class="sp-feature__title">{{ f.title }}</h3>
                  <p class="sp-feature__desc">{{ f.desc }}</p>
                </div>
              </article>
            </div>

            <details class="sp-details" data-anim :style="{ '--d': (i * 120 + 260) + 'ms' }">
              <summary>Exemples concrets</summary>
              <ul>
                <li v-for="(ex, e) in s.examples" :key="e">{{ ex }}</li>
              </ul>
            </details>

            <div class="sp-cta" data-anim :style="{ '--d': (i * 120 + 320) + 'ms' }">
              <button class="sp-btn sp-btn--primary" @click="goHomeTo('#contact1')">
                Demander un devis
              </button>
              <button class="sp-btn sp-btn--soft" @click="goHomeTo('#projects')">
                Voir des projets
              </button>
            </div>
          </div>
        </section>

        <!-- Approche -->
        <section class="sp-approach" id="faq" data-anim style="--d:120ms">
          <h2>Notre <span class="sp-accent">approche</span></h2>
          <div class="sp-approach__grid">
            <article class="sp-qa">
              <h3>01. Cadrage clair</h3>
              <p>Atelier express pour formaliser objectifs, périmètre, risques et indicateurs de succès.</p>
            </article>
            <article class="sp-qa">
              <h3>02. Livraisons itératives</h3>
              <p>Sprints courts, démonstrations fréquentes, feedbacks intégrés. Zéro “big bang”.</p>
            </article>
            <article class="sp-qa">
              <h3>03. Qualité &amp; sécurité</h3>
              <p>CI/CD, revues de code, tests, scans SAST/DAST, surveillance et alertes proactives.</p>
            </article>
            <article class="sp-qa">
              <h3>04. Transfert &amp; montée en compétence</h3>
              <p>Documentation, sessions de prise en main, coaching de vos équipes.</p>
            </article>
          </div>
        </section>

        <!-- Bandeau contact -->
        <section class="sp-contact" data-anim style="--d:220ms">
          <h2>Prêt à lancer&nbsp;? <span class="sp-accent">Parlons de votre projet.</span></h2>
          <p>Un membre de l’équipe vous répond sous 24h.</p>
          <div class="sp-row">
            <button class="sp-btn sp-btn--primary" @click="goHomeTo('#contact1')">
              Contacter SpeDev
            </button>

            <!-- WhatsApp Cameroun -->
            <a class="sp-btn sp-btn--ghost"
               href="https://wa.me/237621077614" target="_blank" rel="noopener">
              WhatsApp (Cameroun): 621-07-76-14
            </a>
          </div>
        </section>
      </main>
    </div>
  </div>
  </section>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Services",
  data() {
    return {
      activeAnchor: "",
      // eslint-disable-next-line vue/no-reserved-keys
      _obs: null,
      sections: [
        /* ===== NOUVEAU : Développement d’applications ===== */
        {
          id: "app-dev",
          theme: "slate",
          title: "Développement d’applications",
          eyebrow: "Web, mobile & API sur-mesure",
          image: new URL("@/assets/services/app-dev.png", import.meta.url).href,
          lead:
            "Conception et réalisation d’applications web/mobile robustes, performantes et sécurisées — de l’architecture à la mise en production.",
          features: [
            { icon: this.i("code"),   title: "Front-end moderne", desc: "Vue/React, SSR/SSG, accessibilité, SEO technique, design system réutilisable." },
            { icon: this.i("mobile"), title: "Mobile first & PWA", desc: "Apps responsives, PWA hors-ligne, ou mobile natif cross-platform (Flutter/React Native)." },
            { icon: this.i("api"),    title: "APIs & intégrations", desc: "REST/GraphQL, Auth/MFA, paiement, fichiers, emails, webhooks et intégration SI." }
          ],
          examples: [
            "SPA Vue/React avec rendu SSR et i18n",
            "Apps mobiles Flutter/React Native",
            "API REST/GraphQL + Auth JWT/Keycloak",
            "Paiement Stripe, notifications, stockage S3"
          ]
        },

        /* ===== Cloud & DevOps ===== */
        {
          id: "cloud-devops",
          theme: "slate",
          title: "Cloud & DevOps",
          eyebrow: "Déploiements sûrs & scalables",
          image: new URL("@/assets/services/cloud-devops.png", import.meta.url).href,
          lead:
            "Automatisez vos livraisons, standardisez vos environnements et gagnez en fiabilité. Nous mettons en place une chaîne CI/CD robuste et une infra cloud optimisée.",
          features: [
            { icon: this.i("server"), title: "CI/CD prêt pour la prod", desc: "Pipelines GitHub Actions/GitLab CI, stratégies de release, rollback rapide." },
            { icon: this.i("k8s"), title: "Conteneurs & orchestration", desc: "Docker, Kubernetes, observabilité (logs/metrics/traces) et autoscaling." },
            { icon: this.i("cloud"), title: "FinOps & sécurité cloud", desc: "Budgets, alertes, politiques IAM minimales, chiffrage au repos/en transit." }
          ],
          examples: [
            "Migration monolithe → microservices",
            "Blue/Green deploy avec tests fumée",
            "Observabilité centralisée (Prometheus + Grafana)"
          ]
        },

        /* ===== Cybersécurité ===== */
        {
          id: "cyber",
          theme: "indigo",
          title: "Cybersécurité",
          eyebrow: "Protégez vos actifs",
          image: new URL("@/assets/services/cybersecurity.png", import.meta.url).href,
          lead:
            "Sécurisez vos applications, données et accès. Nous auditons, testons et renforçons vos systèmes selon les meilleures pratiques.",
          features: [
            { icon: this.i("shield"), title: "Audits & pentests", desc: "OWASP ASVS, tests d’intrusion web/mobile, recommandations actionnables." },
            { icon: this.i("key"), title: "Gouvernance des accès", desc: "IAM, SSO, MFA, rotation des secrets, bastions." },
            { icon: this.i("lock"), title: "Conformité & trace", desc: "Journalisation, rétention, chiffrement, politiques RGPD." }
          ],
          examples: [
            "Durcissement back-office (CSP, headers de sécurité)",
            "SSO + MFA + rôles granulaires",
            "Plan de réponse à incident (IRP)"
          ]
        },

        /* ===== IA & Data ===== */
        {
          id: "ai-data",
          theme: "teal",
          title: "Intelligence Artificielle & Data",
          eyebrow: "De la donnée à la valeur",
          image: new URL("@/assets/services/ai-data.png", import.meta.url).href,
          lead:
            "Exploitez vos données pour la décision ou l’automatisation. De la collecte au modèle, jusqu’au dashboard en temps réel.",
          features: [
            { icon: this.i("spark"), title: "Chatbots & NLP", desc: "Assistants métiers, extraction d’infos, RAG sur vos documents." },
            { icon: this.i("brain"), title: "Recommandation & scoring", desc: "Reco e-commerce, détection d’anomalies, segmentation." },
            { icon: this.i("chart"), title: "Data pipelines & BI", desc: "ETL/ELT, entrepôt de données, dashboards exploitables." }
          ],
          examples: [
            "Assistant SAV connecté au CRM",
            "Reco produits + cross-sell",
            "Dashboard temps réel opérations"
          ]
        },

        /* ===== E-commerce ===== */
        {
          id: "ecommerce",
          theme: "emerald",
          title: "E-commerce & Transactionnel",
          eyebrow: "Vendez en confiance",
          image: new URL("@/assets/services/ecommerce.png", import.meta.url).href,
          lead:
            "Créez une boutique performante, optimisée conversion et intégrée à vos outils de paiement et marketing.",
          features: [
            { icon: this.i("cart"), title: "Boutiques & funnels", desc: "Shopify, WooCommerce ou sur-mesure, SEO & Core Web Vitals." },
            { icon: this.i("credit"), title: "Paiements & conformité", desc: "Stripe/PayPal, SCA, taxes, facturation." },
            { icon: this.i("rocket"), title: "Marketing & CRM", desc: "Emails, automations, segmentation, A/B testing." }
          ],
          examples: [
            "Tunnel d’achat 3 étapes",
            "Marketplace multi-vendeurs",
            "Intégration ERP/CRM, stocks en temps réel"
          ]
        },

        /* ===== IoT ===== */
        {
          id: "iot",
          theme: "cyan",
          title: "IoT (Internet des Objets)",
          eyebrow: "Mesurer, piloter, automatiser",
          image: new URL("@/assets/services/iot.png", import.meta.url).href,
          lead:
            "Connectez vos capteurs et appareils, collectez la donnée, pilotez et visualisez en temps réel.",
          features: [
            { icon: this.i("chip"), title: "Capteurs & gateways", desc: "ESP32/Arduino, MQTT/HTTP, edge processing." },
            { icon: this.i("signal"), title: "Ingestion & temps réel", desc: "Stockage time-series, alertes et webhooks." },
            { icon: this.i("display"), title: "Dashboards & mobile", desc: "Visualisation claire, mobile-first, dark mode." }
          ],
          examples: [
            "Smart home multi-pièces",
            "Monitoring industriel + alertes Slack",
            "API publique pour intégrateurs"
          ]
        },

        /* ===== Formation ===== */
        {
          id: "training",
          theme: "purple",
          title: "Formation & Conseil",
          eyebrow: "Montez en puissance",
          image: new URL("@/assets/services/training.png", import.meta.url).href,
          lead:
            "Formations opérationnelles et coaching d’équipes : front-end, back-end, DevOps, sécurité, data/IA.",
          features: [
            { icon: this.i("class"), title: "Formations sur-mesure", desc: "Programmes adaptés à votre contexte, supports et exercices." },
            { icon: this.i("people"), title: "Coaching d’équipes", desc: "Pair-programming, revues, bonnes pratiques." },
            { icon: this.i("book"), title: "Documentation & handover", desc: "Guides, playbooks, sessions de passation." }
          ],
          examples: [
            "Bootcamp DevOps",
            "Atelier sécurité développeurs",
            "Formation data-viz orientée métier"
          ]
        }
      ]
    };
  },
  mounted() {
    if (window.location.hash) {
      this.activeAnchor = window.location.hash;
      this.$nextTick(() => this.scrollTo(window.location.hash));
    }
    this.initReveal();
    window.addEventListener("scroll", this.onScroll, { passive: true });
  },
  beforeUnmount() {
    if (this._obs) this._obs.disconnect();
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    goTo(hash) {
      this.activeAnchor = hash;
      this.scrollTo(hash);
    },
    goHomeTo(hash) {
      if (this.$route.path !== "/") {
        // eslint-disable-next-line vue/valid-next-tick
        this.$router.push("/").then(() => this.$nextTick(() => this.scrollTo(hash)));
      } else {
        this.scrollTo(hash);
      }
    },
    scrollTo(hash) {
      const el = document.querySelector(hash);
      if (!el) return;
      const NAV_OFFSET = 90;
      const y = el.getBoundingClientRect().top + window.pageYOffset - NAV_OFFSET;
      window.scrollTo({ top: y, behavior: "smooth" });
    },
    onScroll() {
      let current = "";
      for (const s of this.sections) {
        const el = document.getElementById(s.id);
        if (!el) continue;
        const top = el.getBoundingClientRect().top;
        if (top <= 120) current = "#" + s.id;
      }
      if (current) this.activeAnchor = current;
    },
    initReveal() {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        this.$el.querySelectorAll("[data-anim]").forEach((el) => el.classList.add("is-visible"));
        return;
      }
      const els = Array.from(this.$el.querySelectorAll("[data-anim]"));
      this._obs = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add("is-visible");
              obs.unobserve(e.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: "0px 0px -10% 0px" }
      );
      els.forEach((el) => this._obs.observe(el));
      requestAnimationFrame(() => {
        const vh = window.innerHeight * 0.92;
        els.forEach((el) => {
          const r = el.getBoundingClientRect();
          if (r.top < vh && r.bottom > 0) el.classList.add("is-visible");
        });
      });
    },
    // Icônes inline sans dépendances
    i(name) {
      const base = {
        server:`<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="20" height="8" rx="2"/><rect x="2" y="14" width="20" height="8" rx="2"/><path d="M6 6h.01M6 18h.01"/></svg>`,
        k8s:`<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l7 4v8l-7 4-7-4V6z"/><circle cx="12" cy="12" r="2"/></svg>`,
        cloud:`<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17.5 19a4.5 4.5 0 0 0 0-9 7 7 0 0 0-13.5 2"/><path d="M3 19h14.5"/></svg>`,
        shield:`<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l7 4v6c0 5-3.5 9-7 10-3.5-1-7-5-7-10V6z"/></svg>`,
        key:`<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="7.5" cy="7.5" r="3.5"/><path d="M10 10l9 9m0-4l-4 4"/></svg>`,
        lock:`<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="10" rx="2"/><path d="M7 11V7a5 5 0 1 1 10 0v4"/></svg>`,
        spark:`<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2v6M12 16v6M4.93 4.93l4.24 4.24M14.83 14.83l4.24 4.24M2 12h6M16 12h6"/></svg>`,
        brain:`<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M8 6a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3"/><path d="M16 6a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3"/><path d="M8 6c0-2 2-3 4-3s4 1 4 3"/></svg>`,
        chart:`<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3v18h18"/><rect x="7" y="12" width="2" height="6"/><rect x="12" y="9" width="2" height="9"/><rect x="17" y="5" width="2" height="13"/></svg>`,
        cart:`<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="20" r="1"/><circle cx="17" cy="20" r="1"/><path d="M5 6h16l-2 8H7L5 6z"/></svg>`,
        credit:`<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20M7 15h3"/></svg>`,
        rocket:`<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 19l3-3"/><path d="M7 17c4-1 7-4 10-10l2 2C13 12 10 15 9 19L7 17z"/><circle cx="15" cy="9" r="2"/></svg>`,
        chip:`<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="7" y="7" width="10" height="10" rx="2"/><path d="M3 10h4M3 14h4M17 10h4M17 14h4M10 3v4M14 3v4M10 17v4M14 17v4"/></svg>`,
        signal:`<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M2 20h2M6 20v-6h2v6M10 20v-10h2v10M14 20v-14h2v14M18 20v-18h2v18"/></svg>`,
        display:`<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="12" rx="2"/><path d="M8 20h8"/></svg>`,

        /* nouveaux pour App Dev */
        code:`<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 18l6-6-6-6"/><path d="M8 6l-6 6 6 6"/><path d="M14 4l-4 16"/></svg>`,
        mobile:`<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="6" y="2" width="12" height="20" rx="2"/><path d="M12 18h.01"/></svg>`,
        api:`<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="8" rx="2"/><path d="M7 20h10M9 12v8M15 12v8"/></svg>`
      };
      return base[name] || base.server;
    }
  }
};
</script>

<style>
/* ===================== WALLPAPER GLOBAL (ajouté) ===================== */
:root{
  /* Chemins des wallpapers (mets les tiens si besoin) */
  --wp-img-light: url('');
  --wp-img-dark:  url('');

  /* Overlays discrets */
  --wp-overlay-light:
    radial-gradient(1200px 400px at 10% 0%, rgba(103,202,218,.10), transparent 60%),
    radial-gradient(900px 300px at 90% 10%, rgba(103,202,218,.06), transparent 60%);
  --wp-overlay-dark:
    radial-gradient(1200px 400px at 10% 0%, rgba(103,202,218,.10), transparent 60%),
    radial-gradient(900px 300px at 90% 10%, rgba(103,202,218,.08), transparent 60%);

  /* Voiles de lisibilité */
  --wp-veil-light: linear-gradient(180deg, rgba(255,255,255,.70), rgba(255,255,255,.70));
  --wp-veil-dark:  linear-gradient(180deg, rgba(7,9,12,.60), rgba(7,9,12,.60));
}

/* Corps de page : wallpaper clair */
body{
  background-color:#ffffff; /* fallback */
  color:#0f172a;
  transition: background-color .3s ease, color .3s ease;

  background-image:
    var(--wp-overlay-light),
    var(--wp-veil-light),
    var(--wp-img-light),
    linear-gradient(180deg, #ffffff, #ffffff);
  background-size: cover, 100% 100%, cover, 100% 100%;
  background-position: center, center, center, center;
  background-repeat: no-repeat, no-repeat, no-repeat, no-repeat;
  background-attachment: fixed, fixed, fixed, fixed;
}

/* Corps de page : wallpaper sombre */
body.dark{
  background-color:#0f1115; /* fallback */
  color:#e6e8ec;

  background-image:
    var(--wp-overlay-dark),
    var(--wp-veil-dark),
    var(--wp-img-dark),
    linear-gradient(180deg, #0f1115, #0f1115);
  background-size: cover, 100% 100%, cover, 100% 100%;
  background-position: center, center, center, center;
  background-repeat: no-repeat, no-repeat, no-repeat, no-repeat;
  background-attachment: fixed, fixed, fixed, fixed;
}

/* Mobile : éviter le fixed si saccades */
@media (max-width:640px){
  body, body.dark{
    background-attachment: scroll, scroll, scroll, scroll;
  }
}

/* ===================== TOKENS LIGHT (locaux à la page) ===================== */
.services-page {
  --sp-bg:#f8fafc;
  --sp-fg:#0b1324;
  --sp-muted:#475569;
  --sp-line:#e8eef2;
  --sp-card:#ffffff;
  --sp-shadow:0 10px 24px rgba(0,0,0,.1);
  --sp-shadow-lg:0 18px 40px rgba(0,0,0,.18);
  --sp-radius:18px;
  --sp-accent:#67cada;

  /* thèmes visuels (clair) */
  --sp-teal:#e7f7f4;
  --sp-purple:#f2e9f8;
  --sp-indigo:#e8edff;
  --sp-slate:#eef2f6;
  --sp-emerald:#e6f6ef;
  --sp-cyan:#e7f6fb;
  --sp-amber:#fff3e6;   /* <<< nouveau pour App Dev */

  /* >>> fond transparent pour laisser le wallpaper du body */
  background: transparent;
  color:var(--sp-fg);
}
.serv{
  padding-top: 40px;
}

/* ===== HERO ===== */
.services-page .sp-hero{
  background:
    radial-gradient(1200px 400px at 0% 20%, rgba(103,202,218,.10), transparent 60%),
    radial-gradient(800px 300px at 100% 10%, rgba(103,202,218,.08), transparent 60%),
    transparent; /* <<< au lieu de var(--sp-bg) pour voir le wallpaper */
  padding: clamp(48px,6vw,72px) 16px 36px;
  text-align: center;
}
.services-page .sp-hero__wrap{ max-width: 1100px; margin: 0 auto; }
.services-page .sp-badge{
  display:inline-block; padding:8px 14px; border-radius:999px;
  background: rgba(103,202,218,.15); color: var(--sp-accent); font-weight:800;
}
.services-page .sp-title{ font-size: clamp(32px,5vw,54px); line-height:1.06; margin: 10px 0; font-weight: 800; }
.services-page .sp-accent{ color: var(--sp-accent); }
.services-page .sp-subtitle{ max-width: 880px; margin: 0 auto; color: var(--sp-muted); font-size: 1.05rem; }

/* Stats */
.services-page .sp-stats{ display:grid; grid-template-columns: repeat(3,1fr); gap:14px; max-width:720px; margin:22px auto 0; }
.services-page .sp-stat{ background:#fff; border:1px solid var(--sp-line); border-radius: 12px; padding: 12px; box-shadow: var(--sp-shadow); }
.services-page .sp-stat strong{ display:block; font-weight:800; font-size:1.3rem; }
.services-page .sp-stat span{ color:#556; font-size:.95rem; }

/* ===== LAYOUT ===== */
.services-page .sp-layout{
  display:grid; grid-template-columns: 1fr; gap:24px;
  max-width:1200px; margin:0 auto; padding:18px 16px 64px;
}
@media (min-width: 1100px){
  .services-page .sp-layout{ grid-template-columns: 260px 1fr; align-items: start; }
}

/* ===== TOC ===== */
.services-page .sp-toc{
  position: sticky; top: 92px;
  z-index: 3;           /* au-dessus des cartes */
  isolation: isolate;   /* évite les ombres par-dessus */
  background: var(--sp-card);
  border: 1px solid var(--sp-line);
  border-radius: 14px;
  padding: 16px;
  box-shadow: var(--sp-shadow);
}
.services-page .sp-toc__title{ font-weight: 800; margin: 4px 0 10px; }
.services-page .sp-toc ul{ list-style: none; padding: 0; margin: 0; display: grid; gap: 6px; }
.services-page .sp-toc a{
  display:block; padding:8px 10px; border-radius:10px; text-decoration:none;
  color: var(--sp-fg); border: 1px dashed transparent; transition: .18s;
}
.services-page .sp-toc a:hover{ background:#f1fbfd; border-color: rgba(103,202,218,.35); }
services-page .sp-toc a.active,
.services-page .sp-toc a.active{ background:#e6fbf9; color: var(--sp-accent); border-color: rgba(103,202,218,.45); }
.services-page .sp-toc__cta{ margin-top:10px; display:grid; }

/* MOBILE / TABLETTE : TOC non-sticky pour éviter tout chevauchement */
@media (max-width: 1100px){
  .services-page .sp-toc{
    position: static;
    top: auto;
    z-index: 1;
    margin-bottom: 8px;
  }
}

/* ===== CONTENT / BLOCKS ===== */
.services-page .sp-content{ display:grid; gap:26px; }
.services-page .sp-block{
  position: relative; z-index: 1;
  display:grid; gap:18px; align-items:center;
  grid-template-columns: 1fr;
  background: var(--sp-card); border: 1px solid var(--sp-line);
  border-radius: var(--sp-radius); padding: 16px; box-shadow: var(--sp-shadow);
}
@media (min-width: 980px){
  .services-page .sp-block{ grid-template-columns: 1.1fr 1.4fr; padding: 20px; }
  .services-page .sp-block--rev{ grid-template-columns: 1.4fr 1.1fr; }
  .services-page .sp-block--rev .sp-visual{ order: 2; }
  .services-page .sp-block--rev .sp-body{ order: 1; }
}

/* Thèmes de fond doux (cartes thème) */
.services-page .sp-theme--teal    { background: var(--sp-teal); }
.services-page .sp-theme--purple  { background: var(--sp-purple); }
services-page .sp-theme--indigo  { background: var(--sp-indigo); } /* harmless if missed; next line corrects */
.services-page .sp-theme--indigo  { background: var(--sp-indigo); }
.services-page .sp-theme--slate   { background: var(--sp-slate); }
.services-page .sp-theme--emerald { background: var(--sp-emerald); }
.services-page .sp-theme--cyan    { background: var(--sp-cyan); }
.services-page .sp-theme--amber   { background: var(--sp-amber); } /* <<< nouveau */

/* Media */
.services-page .sp-visual{ border-radius: 14px; overflow: hidden; background: #eef6f8; }
.services-page .sp-visual img{ display:block; width:100%; height:100%; object-fit: cover; }

/* Texte */
.services-page .sp-eyebrow{ font-weight:800; color:#2b3a42; opacity:.9; }
.services-page .sp-block__title{ font-size: clamp(22px,3vw,32px); line-height:1.1; margin: 4px 0 6px; font-weight: 900; }
.services-page .sp-lead{ color: var(--sp-muted); margin-bottom: 10px; }

/* Features */
.services-page .sp-features{ display:grid; grid-template-columns: 1fr; gap:10px; }
@media (min-width: 760px){ .services-page .sp-features{ grid-template-columns: 1fr 1fr; } }
.services-page .sp-feature{
  display:grid; grid-template-columns: 28px 1fr; align-items:start; gap:10px;
  padding:10px; border:1px solid #eef2f5; border-radius:12px; background:#fbfeff;
}
.services-page .sp-feature__icon{ color: var(--sp-accent); line-height:0; }
.services-page .sp-feature__title{ font-weight:800; margin:0 0 4px; }
.services-page .sp-feature__desc{ margin:0; color:#4b5563; }

/* Details */
.services-page .sp-details{
  margin-top:8px; border:1px dashed #dbe7ee; border-radius:12px; padding:10px 12px; background:#fcfeff;
}
services-page .sp-details summary{ cursor:pointer; font-weight:800; color:#374159; } /* harmless if missed; next line corrects */
.services-page .sp-details summary{ cursor:pointer; font-weight:800; color:#374159; }
.services-page .sp-details ul{ margin:8px 0 0 18px; display:grid; gap:4px; }

/* CTA */
.services-page .sp-cta{ display:flex; gap:10px; margin-top:12px; flex-wrap:wrap; }
.services-page .sp-btn{
  display:inline-flex; align-items:center; justify-content:center;
  gap:8px; padding:12px 16px; border-radius:12px; border:1px solid transparent;
  font-weight:800; cursor:pointer; text-decoration:none; transition:.2s;
}
.services-page .sp-btn--primary{ background: var(--sp-accent); color:#0b0d12; box-shadow: 0 10px 24px rgba(103,202,218,.35); }
.services-page .sp-btn--primary:hover{ transform: translateY(-1px); background:#50b5c4; }
.services-page .sp-btn--soft{ background:#e9f7fa; color:#374159; border-color:#cbeef4; }
.services-page .sp-btn--soft:hover{ background:#dff3f7; }
.services-page .sp-btn--ghost{ background: transparent; border-color: #d5e7ed; color: var(--sp-fg); }
.services-page .sp-btn--ghost:hover{ background:#f6fcfd; }

/* Approach */
services-page .sp-approach{ background: var(--sp-card); } /* harmless; next line corrects */
.services-page .sp-approach{
  background: var(--sp-card); border:1px solid var(--sp-line); border-radius: var(--sp-radius);
  padding: 18px; box-shadow: var(--sp-shadow); text-align: center;
}
.services-page .sp-approach h2{ font-size: clamp(24px,3vw,34px); margin: 0 0 6px; }
.services-page .sp-approach__grid{ display:grid; grid-template-columns: 1fr; gap: 12px; margin-top: 10px; text-align: left; }
@media (min-width: 860px){ .services-page .sp-approach__grid{ grid-template-columns: repeat(4,1fr); } }
.services-page .sp-qa{ background:#fbfeff; border:1px solid #eef2f5; border-radius: 12px; padding: 12px; }
.services-page .sp-qa h3{ margin:0 0 6px; font-weight: 900; }

/* Contact callout */
.services-page .sp-contact{
  border:1px solid var(--sp-line); background: #0b1324; color:#e6e8ec;
  border-radius: var(--sp-radius); padding: 22px; text-align: center;
}
.services-page .sp-contact .sp-row{ display:flex; gap:10px; justify-content:center; flex-wrap:wrap; }
.services-page .sp-contact .sp-btn--primary{ background: var(--sp-accent); }
.services-page .sp-contact .sp-btn--ghost{ color:#e6e8ec;
  border-color:#344055;
  background: rgba(255,255,255,0.06); }
  .services-page .sp-contact .sp-btn--ghost:hover,
.services-page .sp-contact .sp-btn--ghost:focus-visible{
  background: rgba(255,255,255,0.14); /* + de contraste au survol */
  border-color:#4a5a78;
  color:#ffffff;                       /* texte bien lisible */
  box-shadow: 0 0 0 3px rgba(103,202,218,.25); /* focus visible clavier */
  outline: none;
}

/* Confort d’ancre pour la navbar sticky globale */
.services-page [id]{ scroll-margin-top: 92px; }

/* ===== REVEAL local ===== */
.services-page [data-anim]{
  opacity:0; transform: translateY(18px);
  transition: opacity .7s cubic-bezier(.22,.61,.36,1), transform .7s cubic-bezier(.22,.61,.36,1);
  transition-delay: var(--d, 0ms); will-change: opacity, transform;
}
.services-page [data-anim].is-visible{ opacity:1; transform:none; }

/* ===== MOBILE ===== */
@media (max-width:520px){
  .services-page .sp-block{ padding:16px; }
  .services-page .sp-hero{ padding-top:56px; }
}
</style>

